import PaginateModel from "@/model/paginate";
import AdminUser from "@/model/adminUser";
import api from "./api";
import { AxiosResponse } from "axios";

interface AdminUserList {
  list: AdminUser[];
  paginate: any;
}

class AdminUserApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getAllUsers(query): Promise<AdminUserList> {
    const response = await this.getHttp().get<any>("supper-admins", {
      params: query,
    });

    const list = response.data.data.data.map((userDto) => {
      return new AdminUser(userDto);
    });

    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list: list,
      paginate: paginate,
    };
  }

  async add(data: AdminUser): Promise<AxiosResponse> {
    return this.getHttp().post<any>("supper-admins", data);
  }

  async update(data: AdminUser, id): Promise<AxiosResponse> {
    console.log(data);
    return this.getHttp().put<any>("supper-admins/" + id, data);
  }

  async delete(id): Promise<AxiosResponse> {
    return this.getHttp().delete<any>("supper-admins/" + id);
  }
}
export default new AdminUserApi();
